var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "kid_star"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3090_14257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3090_14257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kid_star_2",
    d: "M3.17725 2.66683L4.34391 1.15641C4.42725 1.0453 4.5262 0.963704 4.64079 0.911621C4.75537 0.859538 4.87516 0.833496 5.00016 0.833496C5.12516 0.833496 5.24495 0.859538 5.35954 0.911621C5.47412 0.963704 5.57308 1.0453 5.65641 1.15641L6.82308 2.66683L8.59391 3.26058C8.77447 3.31613 8.91683 3.41857 9.021 3.56787C9.12516 3.71718 9.17725 3.88211 9.17725 4.06266C9.17725 4.146 9.16509 4.22933 9.14079 4.31266C9.11648 4.396 9.07655 4.47586 9.021 4.55225L7.87516 6.17725L7.91683 7.88558C7.92377 8.12864 7.84391 8.3335 7.67725 8.50016C7.51058 8.66683 7.31614 8.75016 7.09391 8.75016C7.08002 8.75016 7.00364 8.73975 6.86475 8.71891L5.00016 8.19808L3.13558 8.71891C3.10086 8.7328 3.06266 8.74148 3.021 8.74495C2.97933 8.74843 2.94113 8.75016 2.90641 8.75016C2.68419 8.75016 2.48975 8.66683 2.32308 8.50016C2.15641 8.3335 2.07655 8.12864 2.0835 7.88558L2.12516 6.16683L0.989746 4.55225C0.934191 4.47586 0.89426 4.396 0.869954 4.31266C0.845649 4.22933 0.833496 4.146 0.833496 4.06266C0.833496 3.88905 0.883843 3.72759 0.984538 3.57829C1.08523 3.42898 1.22586 3.32308 1.40641 3.26058L3.17725 2.66683Z",
    fill: "#FFBB00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star_yellow.9a6c8e415a044682fe2090dbd5b4792f.svg";
export { ForwardRef as ReactComponent };